import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "settings 3, gear, preferences" }, [
      _createElementVNode("g", { id: "Icon" }, [
        _createElementVNode("path", {
          d: "M6.29846 4.28462L5.98025 4.21119C5.48466 4.09682 4.96511 4.24582 4.60547 4.60547C4.24582 4.96511 4.09682 5.48466 4.21119 5.98025L4.28462 6.29846C4.4777 7.13515 4.13269 8.00399 3.41823 8.4803L2.93434 8.80289C2.53365 9.07002 2.29297 9.51973 2.29297 10.0013C2.29297 10.4829 2.53365 10.9326 2.93434 11.1997L3.41823 11.5223C4.13269 11.9986 4.4777 12.8675 4.28462 13.7041L4.21119 14.0224C4.09682 14.5179 4.24583 15.0375 4.60547 15.3971C4.96511 15.7568 5.48466 15.9058 5.98025 15.7914L6.29846 15.718C7.13515 15.5249 8.00399 15.8699 8.4803 16.5844L8.80289 17.0683C9.07002 17.469 9.51973 17.7096 10.0013 17.7096C10.4829 17.7096 10.9326 17.469 11.1997 17.0683L11.5223 16.5844C11.9986 15.8699 12.8675 15.5249 13.7041 15.718L14.0224 15.7914C14.5179 15.9058 15.0375 15.7568 15.3971 15.3971C15.7568 15.0375 15.9058 14.5179 15.7914 14.0224L15.718 13.7041C15.5249 12.8675 15.8699 11.9986 16.5844 11.5223L17.0683 11.1997C17.469 10.9326 17.7096 10.4829 17.7096 10.0013C17.7096 9.51973 17.469 9.07002 17.0683 8.80289L16.5844 8.4803C15.8699 8.00399 15.5249 7.13515 15.718 6.29846L15.7914 5.98025C15.9058 5.48466 15.7568 4.96511 15.3971 4.60547C15.0375 4.24583 14.5179 4.09682 14.0224 4.21119L13.7041 4.28462C12.8675 4.4777 11.9986 4.13269 11.5223 3.41823L11.1997 2.93434C10.9326 2.53365 10.4829 2.29297 10.0013 2.29297C9.51973 2.29297 9.07002 2.53365 8.80289 2.93434L8.4803 3.41823C8.00399 4.13269 7.13515 4.4777 6.29846 4.28462Z",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M12.293 10.0013C12.293 11.267 11.267 12.293 10.0013 12.293C8.73565 12.293 7.70964 11.267 7.70964 10.0013C7.70964 8.73565 8.73565 7.70964 10.0013 7.70964C11.267 7.70964 12.293 8.73565 12.293 10.0013Z",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linejoin": "round"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }